import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import _ from 'lodash';
import { FishingReport } from '@omniafishing/core';
import { sortReportsByOutingDateOrAcceptedAt } from '../../../../lib/fishing_reports';

dayjs.extend(advancedFormat);

export const sortReportsByMostRelevant = (reports: FishingReport[]) => {
  const reportsSortedByOutingAndAcceptedDate = sortReportsByOutingDateOrAcceptedAt(reports);

  const todaysDate = dayjs();
  const todayDayOfYear = todaysDate.dayOfYear();
  const fortyFiveDaysAgoDate = dayjs().subtract(45, 'day');

  return _.sortBy(reportsSortedByOutingAndAcceptedDate, (fishingReport) => {
    const reportDate = dayjs(fishingReport.outing_date || fishingReport.accepted_at);
    const isWithin45DaysAgo = reportDate <= todaysDate && reportDate >= fortyFiveDaysAgoDate;

    const reportDayOfYear = reportDate.dayOfYear();

    if (isWithin45DaysAgo) {
      return 0;
    }

    const dayOfYearDifference = Math.min(
      Math.abs(reportDayOfYear - todayDayOfYear),
      365 - Math.abs(reportDayOfYear - todayDayOfYear)
    );

    return dayOfYearDifference;
  });
};
